import { GoAFormItem, GoAInputDate, GoAInputText } from '@abgov/react-components';
import * as React from 'react';
import { IFlightReport } from '../../model/IFlightReport';
import { USStandToStandDown } from '../../model/Unserviceable/IUSStandToStandDown';
import { updateHourWithColon, validateHoursMinutes } from '../../utils/checkInput';

interface IEditStandToStandDownTimeProps {
  flightReport: IFlightReport;
  uSStandToStandDown: USStandToStandDown | undefined;
  onChange: (value: USStandToStandDown) => void;
}
export function setUsStandToStandDownErrors(value?: USStandToStandDown): boolean {
  if (!value) return false;
  let hasError = false;
  if (value.standTo) {
    if (validateHoursMinutes(value.standTo, 2)) {
      value.standDownError = '';
      value.standToError = '';
    } else {
      value.standToError = 'hh:mm valid format';
      hasError = true;
    }
  } else {
    value.standToError = 'Required to save';
    hasError = true;
  }
  if (value.standDown) {
    if (validateHoursMinutes(value.standDown, 2)) {
      value.standDownError = '';
      value.standToError = '';
    } else {
      value.standDownError = 'hh:mm valid format';
      hasError = true;
    }
  } else {
    value.standDownError = 'Required to save';
    hasError = true;
  }
  return hasError;
}
const EditStandToStandDownTime: React.FunctionComponent<IEditStandToStandDownTimeProps> = ({
  flightReport,
  uSStandToStandDown,
  onChange,
  ...props
}) => {
  const [standToError, setStandToError] = React.useState('');
  const [standDownError, setStandDownError] = React.useState('');

  //on property values change
  function onPropertyChange(value: Partial<USStandToStandDown>) {
    let newValue = new USStandToStandDown();
    newValue = new USStandToStandDown({ ...uSStandToStandDown, ...value });

    onChange(newValue);
  }

  return (
    <>
      <div className='row section-margin-top-20'>
        <div className='width100'>
          <div className='column width100'>
            <div className='row accordion unserviceableReport'>
              <div>
                <div>
                  <h3 className='insideHeader expense-section-header'>Stand To / Stand Down Time</h3>
                </div>
                <div className='content standToStandDown'>
                  <div className='width25 col-md-6'>
                    <GoAFormItem label='Unserviceable Date'>
                      <GoAInputDate
                        name='dtUnserviceableDate'
                        placeholder='YYYY-MM-DD'
                        value={
                          uSStandToStandDown?.unserviceableDate && uSStandToStandDown?.unserviceableDate !== ''
                            ? uSStandToStandDown?.unserviceableDate
                            : flightReport?.flightReportDate
                        }
                        min={new Date(1950, 1, 1)}
                        max={new Date()}
                        width='100%'
                        disabled={true}
                        onChange={(name, value) => {}}
                      />
                    </GoAFormItem>
                  </div>
                  <div className='width25 col-md-6'>
                    <GoAFormItem label='Stand To' error={standToError}>
                      <GoAInputText
                        name='txtUnserviceableStandTo'
                        value={uSStandToStandDown?.standTo && uSStandToStandDown?.standTo !== '' ? uSStandToStandDown?.standTo : ''}
                        width='100%'
                        maxLength={5}
                        placeholder='hh:mm'
                        error={standToError ? true : false}
                        onChange={(name, value) => {
                          if (value) {
                            if (validateHoursMinutes(value, 2)) {
                              setStandToError('');

                              setStandDownError('');

                              onPropertyChange({
                                standTo: value,
                              });
                            } else {
                              setStandToError('hh:mm valid format');
                              const updatedValue = updateHourWithColon(value);
                              onPropertyChange({
                                standTo: updatedValue,
                              });
                            }
                          } else {
                            setStandToError('Required to save');
                            onPropertyChange({
                              standTo: undefined,
                            });
                          }
                        }}
                      />
                    </GoAFormItem>
                  </div>
                  <div className='width25 col-md-6'>
                    <GoAFormItem label='Stand Down' error={standDownError}>
                      <GoAInputText
                        name='txtUnserviceableStandDown'
                        value={uSStandToStandDown?.standDown && uSStandToStandDown?.standDown !== '' ? uSStandToStandDown?.standDown : ''}
                        width='100%'
                        maxLength={5}
                        placeholder='hh:mm'
                        error={standDownError ? true : false}
                        onChange={(name, value) => {
                          if (value) {
                            if (validateHoursMinutes(value, 2)) {
                              setStandDownError('');

                              setStandToError('');

                              onPropertyChange({
                                standDown: value,
                              });
                            } else {
                              setStandDownError('hh:mm valid format');
                              const updatedValue = updateHourWithColon(value);
                              onPropertyChange({
                                standDown: updatedValue,
                              });
                            }
                          } else {
                            setStandDownError('Required to save');
                            onPropertyChange({
                              standDown: undefined,
                            });
                          }
                        }}
                      />
                    </GoAFormItem>
                  </div>
                  <div className='width25 col-md-6'>
                    <GoAFormItem label='Total Hours'>
                      <GoAInputText
                        name='txtUnserviceableTotalHours'
                        value={uSStandToStandDown?.totalHours && uSStandToStandDown?.totalHours !== '' ? uSStandToStandDown?.totalHours : ''}
                        width='100%'
                        maxLength={10}
                        disabled={true}
                        onChange={(name: any, value: any) => {}}
                      />
                    </GoAFormItem>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditStandToStandDownTime;
